module.exports = __webpack_public_path__ + "static/img/product02-6.4e1cb7fa.png";